@if (visible) {
  <div
    class="deploy-banner"
    [class.deploy-banner--yellow]="phase === 'yellow'"
    [class.deploy-banner--red]="phase === 'red'"
  >
    <div class="deploy-banner__body">
      <mat-icon class="deploy-banner__icon">
        {{ phase === 'green' ? 'system_update_alt' : phase === 'yellow' ? 'warning_amber' : 'error_outline' }}
      </mat-icon>

      <p class="deploy-banner__text">
        <span class="deploy-banner__title">
          {{ phase === 'green' ? 'Nueva versión disponible.' : phase === 'yellow' ? 'La sesión se cerrará pronto.' : 'Cierre de sesión inminente.' }}
        </span>
        <span class="hidden sm:inline">
          {{ phase === 'green' ? ' Guarda tu trabajo — se cerrará en ' : phase === 'yellow' ? ' Guarda tu trabajo — cierre en ' : ' Se cerrará en ' }}
        </span>
        <span class="deploy-banner__countdown">{{ formattedTime }}</span>
        <span class="sm:hidden"> restante{{ paused ? ' (pausado)' : '' }}</span>
        <span class="hidden sm:inline">{{ paused ? ' · pausado' : '' }}</span>
      </p>

      <button
        mat-stroked-button
        class="deploy-banner__btn"
        (click)="update()"
      >
        <mat-icon class="mr-1 text-sm">logout</mat-icon>
        <span class="hidden sm:inline">Actualizar y salir</span>
        <span class="sm:hidden">Actualizar</span>
      </button>
    </div>

    <div
      class="deploy-banner__progress"
      [style.width.%]="progressPct"
    ></div>
  </div>
}
